import { render, staticRenderFns } from "./box1new.vue?vue&type=template&id=0ad7ccb3&scoped=true&"
import script from "./box1new.vue?vue&type=script&lang=ts&"
export * from "./box1new.vue?vue&type=script&lang=ts&"
import style0 from "./box1new.vue?vue&type=style&index=0&id=0ad7ccb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad7ccb3",
  null
  
)

export default component.exports